<template>
  <div>
    <modal
      :adaptive="true"
      :clickToClose="false"
      :height="'auto'"
      :reset="true"
      :scrollable="true"
      :width="700"
      name="modal"
    >
      <div class="popup-new">
        <button class="popup-new__close" type="button" @click="closeModal"></button>
        <div class="popup-new__title">Update Reservation | <span>{{ resData.group_name }}</span></div>
        <div class="popup-new__body">
          <AppFlexGrid :rows="[[1, '100px', '222px'], ['240px', '240px', 1], ['max-content']]">
            <template #header-1>
              <h3 class="title title--mb15 title--family title--grey">Room Configuration</h3>
            </template>
            <template #col-1-1>
              <app-select
                v-model="form.room_category"
                :options="roomCategories"
                :clearable="false"
                placeholder="Select Room"
                class="family"
              />
            </template>
            <template #col-1-2>
              <app-input
                v-model.number="form.count"
                type="number"
                id="qty"
                placeholder="Qty"
                name="qty"
                class="family"
              />
            </template>
            <template #col-1-3>
              <app-cells :indent="false" gap="12px">
                <HMAgeAssignment
                  v-if="form.accomodation_type"
                  @input="rmpShow = true"
                  :accomodation-type="form.accomodation_type"
                />
                <HMButton
                  @click.native="rmpShow = true"
                  color="#8d95a4"
                  background="linear-gradient(0deg, #D9DFE8 0%, #E4E8EF 100%)"
                  :disabled="!form.room_category || hasSingleAT"
                >
                  <template v-if="!form.accomodation_type">
                    <img src="@/assets/img/hm/man.svg" alt="">
                    <span>Configure Room</span>
                  </template>
                  <img v-else src="@/assets/img/hm/pen-grey.svg" alt="">
                </HMButton>
              </app-cells>
            </template>
            <template #col-2-1>
              <div style="position: relative;">
                <app-date-picker
                  @input="onCreateCheckInInput"
                  v-model="form.check_in"
                  class="family"
                  placeholder="Check-in"
                  :clearable="false"
                  :disabled-date="disablePastDates"
                  :default-value="resData.start_date"
                />
                <img style="position: absolute; top: calc(50% - 5px); right: -16px;" src="@/assets/img/hm/arrow-right-grey.svg" alt="">
              </div>
            </template>
            <template #col-2-2>
              <app-date-picker
                v-model="form.check_out"
                class="family"
                placeholder="Check-out"
                :clearable="false"
                :disabled="!form.check_in"
                :disabled-date="disableDatesFromCheckIn"
                :default-value="form.check_in"
                ref="check_out"
              />
            </template>
            <template #col-2-3>
              <HMTower horizontal>
                <template #title>Nights:</template>
                <template #body>
                  <HMChip>
                    {{ numberOfNights || '-' }}
                    <template #icon>
                      <NightsIcon aria-hidden="true"/>
                    </template>
                  </HMChip>
                </template>
              </HMTower>
            </template>
            <template #col-3-1>
              <app-cells :indent="false">
                <HMButton
                  @click.native="addConfigurationToRoomsSummary"
                  color="#8d95a4"
                  background="linear-gradient(0deg, #D9DFE8 0%, #E4E8EF 100%)"
                  :disabled="isDuplicateRoomConfig"
                >
                  <img src="@/assets/img/hm/plus-grey.svg" alt="">
                  <span>Add room to reservation</span>
                </HMButton>
                <MiniNotification v-if="isDuplicateRoomConfig" max-width="300px">
                  This room configuration is already added.
                  Change the details to add another.
                </MiniNotification>
              </app-cells>
            </template>
          </AppFlexGrid>
          <hr style="margin-bottom: 20px">
          <h3 class="title title--mb15 title--family title--grey">Rooms Summary</h3>
          <app-cells-grid
            v-if="shortRooms.length !== 0 && shortRooms.length"
            :columns="1"
            :margin-bottom="30"
            gap="10px"
          >
            <HotelShortRoomEdit
              v-for="(item, index) in shortRooms"
              :key="`room_${index}`"
              @update-field="onUpdateField(index, $event)"
              @card-cancel="onCardCancel(index)"
              @card-delete="onCardDelete(index)"
              @card-restore="onCardRestore(index)"
              :order-number="index + 1"
              :room="item"
              :mp="resData.meal_plan"
            />
          </app-cells-grid>
          <hr style="margin-bottom: 20px; margin-top: 30px">
          <app-cells :indent="false" position="end">
            <HMButton @click.native="onSaveRooms" :disabled="shortRooms.length === 0" :loading="isSubmitting">
              Save
            </HMButton>
          </app-cells>
        </div>
      </div>
    </modal>
    <div v-if="rmpShow" class="hc-popover" ref="rmp" :style="rmpStyles">
      <div class="hc-popover__body">
        <button @click="rmpShow = false" class="hc-popover__close" type="button">
          <CloseSearch/>
        </button>
        <div class="hc-popover__wrapper">
          <div class="hc-popover__top">
            <div class="hc-popover__title">
              {{ form.room_category.name }} <span>| Room Configurations</span>
            </div>
          </div>
          <div class="hc-popover__meta">Please select configuration that suits your guests.</div>
          <app-form-field label="Available options:" class="family">
            <div class="hc-popover__scroll">
              <app-cells :indent="false">
                <HMAgeAssignment
                  v-for="item in form.room_category.accomodation_types"
                  :key="`accomodation_type_${form.room_category.id}_${item.code}`"
                  @input="rmpShow = false"
                  v-model="form.accomodation_type"
                  :accomodation-type="item"
                />
              </app-cells>
            </div>
          </app-form-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHotelManagementRoomCategories, postHotelManagementReservationsShortRooms } from '@/http'
import { addDays } from 'date-fns'
import NightsIcon from '@/views/hotel-management/reservations/detail/icons/NightsIcon.vue'
import HMAgeAssignment from '@/components/HMAgeAssignment.vue'
import MiniNotification from '@/components/MiniNotification.vue'
import HMTower from '@/components/HMTower.vue'
import HMChip from '@/views/hotel-management/reservations/components/HMChip.vue'
import HMButton from '@/views/hotel-management/reservations/components/HMButton.vue'
import CloseSearch from '@/views/hotel-management/calendar/icons/CloseSearch.vue'
import HotelShortRoomEdit from '@/components/HotelShortRoomEdit.vue'

export default {
  name: 'EditRoomsSummaryModal',
  components: {
    HotelShortRoomEdit,
    CloseSearch,
    HMButton,
    HMChip,
    HMTower,
    MiniNotification,
    HMAgeAssignment,
    NightsIcon
  },
  props: {
    showModal: { type: Boolean, default: false },
    resData: { type: Object, required: true }
  },
  data() {
    return {
      form: { check_out: '' },
      shortRooms: [],
      roomCategories: [],
      rmpShow: false,
      isSubmitting: false,
    }
  },
  watch: {
    showModal(val) {
      if (val) {
        this.getRoomCategories()
        this.$modal.show('modal')
      } else this.$modal.hide('modal')
    },
    'form.room_category': {
      handler(category) {
        const list = category.accomodation_types
        if (list.length === 1) this.form.accomodation_type = list[0]
      },
      immediate: false
    },
    'form.count'(val) {
      this.form.count = val < 1 ? 1 : Math.floor(val)
    },
  },
  computed: {
    isDuplicateRoomConfig() {
      const f = this.form || {}
      const hasAll =
        f.room_category?.id &&
        f.accomodation_type?.code &&
        f.check_in &&
        f.check_out

      if (!hasAll) return false

      const norm = (v) => {
        const d = this.normalizeDate(v)
        return d.getTime()
      }

      return this.shortRooms.some((item) => {
        if (item.is_cancelled) return false
        return (
          item?.room_category?.id === f.room_category.id &&
          item?.accomodation_type?.code === f.accomodation_type.code &&
          norm(item.check_in) === norm(f.check_in) &&
          norm(item.check_out) === norm(f.check_out)
        )
      })
    },
    hasSingleAT() {
      const category = this.form && this.form.room_category
      const list = category ? category.accomodation_types : []

      return list.length === 1
    },
    numberOfNights() {
      if (this.form.check_in && this.form.check_out) {
        const date1 = new Date(this.form.check_in)
        const date2 = new Date(this.form.check_out)
        const timeDiff = date2.getTime() - date1.getTime()

        return Math.ceil(timeDiff / (1000 * 3600 * 24)) < 0 ? 0 : Math.ceil(timeDiff / (1000 * 3600 * 24))
      } else return null
    },
    rmpStyles() {
      return {
        left: '50%',
        top: 'calc(50% + 100px)',
        transform: 'translate(-50%, -50%)'
      }
    },
  },
  methods: {
    onSaveRooms() {
      this.isSubmitting = true
      postHotelManagementReservationsShortRooms(this.$route.params.id, this.normalizeForm())
        .finally(() => { this.isSubmitting = false })
        .then(res => { this.$modal.hide('modal') })
    },
    normalizeForm() {
      let form = []

      form = this.shortRooms
        .filter(item => !item.is_cancelled)
        .map(item => {
          return {
            id: item.id || null,
            room_category: item.room_category.id,
            accomodation_type: item.accomodation_type.code,
            check_in: item.check_in,
            check_out: item.check_out,
            count: item.count,
          }
        })

      return form
    },
    onUpdateField(index, { field, value }) {
      this.$set(this.shortRooms[index], field, value)
    },
    onCardDelete(index) {
      this.shortRooms.splice(index, 1)
    },
    onCardCancel(index) {
      this.shortRooms[index].is_cancelled = true
    },
    onCardRestore(index) {
      this.shortRooms[index].is_cancelled = false
    },
    addConfigurationToRoomsSummary() {
      this.shortRooms.push({ ...this.form, nights: this.numberOfNights })
    },
    onCreateCheckInInput() {
      this.$nextTick(() => {
        this.form.check_out = ''
        this.$refs.check_out.$children[0].focus()
      })
    },
    closeModal() {
      this.$emit('update:showModal', false)
    },
    async getRoomCategories() {
      const response = await getHotelManagementRoomCategories({ property: this.resData.property.code })

      this.roomCategories = response.data
      this.convertShortRooms()
    },
    convertShortRooms() {
      this.shortRooms = [ ...this.resData.short_rooms ].map(item => ({ ...item, is_cancelled: false }))
    },
    disablePastDates(date) {
      const d = this.normalizeDate(date)
      const today = this.normalizeDate(new Date())
      return d < today
    },
    disableDatesFromCheckIn(date) {
      const d = this.normalizeDate(date)
      const check_in = this.normalizeDate(this.form.check_in)
      const max = addDays(check_in, 10)

      return d <= check_in || d > max
    },
    normalizeDate(val) {
      const date = new Date(val)
      date.setHours(0, 0, 0, 0)
      return date
    },
  }
}
</script>

<style scoped>
hr {
  padding: 0;
  height: 0;
  border: none;
  border-top: 1px solid #e9e9e9;
}
</style>